import './index.css'

// Registers the vite:preloadError recovery handler. MUST be imported before
// './App' so the listener exists before the router's eager SignIn.preload()
// fires its dynamic import (ENG-1569).
import './chunkReload'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material'
import ReactDOM from 'react-dom/client'

import { theme } from '@/styles/theme'

import Bootstrap from '@/components/Bootstrap'
import App from './App'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Bootstrap>
      <App />
    </Bootstrap>
  </ThemeProvider>
)
